import { useI18n } from 'vue-i18n';
<script lang="ts" setup>
const { locale } = useI18n()
</script>

<template>
  <div class="textEditor dialogContribute" v-if="locale === 'zh'">
    <div class="dialogContribute__mainTitle">投稿須知</div>
    <div class="dialogContribute__item">
      IW全新數位平台將持續匯集並報導生活空間美學，反映設計時尚，傳遞優質生活觀念。內容將精選國內、外卓越建築與空間作品，更包含人文、藝術、與工業設計等相關內容。
      <br />
      <br />
      以下為數位文章投稿所需悉知之資訊：
      <br />
      <br />
      1. 投稿內容資訊請確實正確填寫，以便後續審稿及聯絡作業。<br /><br />
      2. 投稿後須 1-2 週審核期，屆時傢飾編輯團隊將以 Email 通知您是否採用或索取其他資料。<br /><br />
      3.
      作品圖檔上傳：為清楚傳達個案設計理念，歡迎上傳作品設計過程之平面、立面、3D圖等完整作品資訊，並上傳30張以內作品正片（eps、png、jpg圖片檔格式，每張5MB以內），超過30張則可以雲端連結提供，以利編輯編排刊登，由內而外將您的作品多方面呈現與敘述，展現空間/建築之美。<br /><br />
      4.
      作品敘述：若方便建議輸入中英文內文以及空間基本資料（團隊資訊、主要材料、空間性質、空間面積、攝影團隊等．．．）以及500-1000字文案描述此案所呈現的理念、機能、風格、設計手法等。（若無英文翻譯則將由傢飾數位部做編輯），若已備內容檔案也可提供雲端網址。<br /><br />
      5. 提交投稿資料後即表示您同意與授權IW傢飾雜誌使用您所提供的內容，並有權編輯文字與排版的權利，以便發佈相關報導。<br />
    </div>
  </div>
  <div class="textEditor dialogContribute" v-if="locale === 'en'">
    <div class="dialogContribute__mainTitle">Submit Information</div>
    <div class="dialogContribute__item">
      This is IW Magazine, the most popular premier architecture & design magazine serving the Mandarin-speaking world.
      We
      reports on the aesthetics of living space, reflects the design trends, and delivers a fine lifestyle, especially
      for
      readers who value the quality and the taste of life.
      <br />
      <br />
      We collect international excellent viewpoints, including architecture, interior design, industrial design,
      humanity,
      and contemporary art, editing with a detailed but macroscopic perspective.
      <br />
      <br />
      1. Please fill in the information correctly and accurately to facilitate subsequent review and contact.
      <br /><br />
      2. 1-2 weeks review period is required after submission, IW Team will notify you by email whether to adopt or
      request for other information.<br /><br />
      3. <span class="entitle">Project Images</span>: In order to clearly convey the design concept of the case,
      you are welcome to upload the
      complete
      artwork information such as plan, elevation, 3D drawings, etc. of the design process, as well as uploading up to
      30
      project images (eps, png, jpg image file format, each within 5MB), if more than 30 images can be provided with a
      cloud link for us to arrange and publish the project detailed and completely, presenting your work from all
      aspects
      and describing the beauty of space/architecture. <br /><br />
      4. <span class="entitle">Project Description</span>: It is recommended to enter both Chinese and English
      text and project information (such as
      team credit, main materials, character of space, total area, photography team, etc. ...) and 500-1000 words text
      about the concept, function, style, design approach, etc. of the project. (If there is no English/Chinese
      translation, it will be edited by IW), or you can provide the cloud URL if you have already prepared the content
      file.<br /><br />
      5. By submitting your submission, you agree and authorize IW Furniture Magazine to use the content you provide and
      have the right to edit the text and layout in order to publish relevant reports.<br />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dialogContribute {
  line-height: 2;

  &__mainTitle {
    margin-bottom: 90px;
    font-size: 16px;
    color: rgba(#000, 0.8);
    line-height: 1.5;
    border: 1px solid rgba(#000, 0.8);
    text-align: center;
    padding: 16px 20px;

    @include max-media(480) {
      font-size: 14px;
      padding-top: 12px;
      padding-bottom: 12px;
      margin-bottom: 45px;
    }
  }

  &__item {
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;

    @include max-media(480) {
      font-size: 12px;
    }

    &:not(:last-child) {
      margin-bottom: 50px;
    }
  }

  &__title {
    width: 100px;

    @include max-media(480) {
      width: 100%;
      font-weight: 700;
      margin-bottom: 20px;
    }
  }

  &__right {
    flex: 1;
    padding-left: 45px;

    @include max-media(480) {
      padding-left: 0;
    }
  }
}

.entitle {
  display: contents;
  font-weight: 700;
}
</style>
